var _path, _path2, _path3, _ellipse, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0883 25.1596C43.0883 35.9813 33.592 44.8192 21.7941 44.8192C9.99629 44.8192 0.5 35.9813 0.5 25.1596C0.5 14.3379 9.99629 5.5 21.7941 5.5C33.592 5.5 43.0883 14.3379 43.0883 25.1596Z",
    fill: "white",
    stroke: "#282750"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4249 36.0164L11.1533 28.722L14.1876 24.4824L20.3235 28.8487L28.9318 17.5605L33.1049 20.7048L21.4249 36.0164Z",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4729 13.25C45.9695 13.25 39.0693 20.7978 39.0693 30.1039C39.0693 39.4101 45.962 46.9579 54.4729 46.9579C62.9763 46.9579 77.2411 38.4415 77.2411 29.1279C77.2411 24.0612 68.423 16.3421 65.1865 13.25C65.1865 13.25 58.3462 13.25 54.4729 13.25Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.2742,
    cy: 28.2346,
    rx: 12.5593,
    ry: 11.6174,
    fill: "#282750"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.992 115.284L100.992 72.6426L17.8535 72.6426L17.8535 115.284L100.992 115.284Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0243 86.5769H80.3856C79.9436 86.5769 79.584 86.2192 79.584 85.7796V83.6859C79.584 83.2463 79.9436 82.8887 80.3856 82.8887H91.0243C91.4663 82.8887 91.8259 83.2463 91.8259 83.6859V85.7796C91.8259 86.2192 91.4663 86.5769 91.0243 86.5769Z",
    fill: "#282750"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.432 74.851V73.1895L18.2669 73.1895V74.851L100.432 74.851Z",
    fill: "#FEF6E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.435 73.1855H98.7646V114.627H100.435V73.1855Z",
    fill: "#FEF6E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7821 80.8765L50.8359 84.3262L52.4414 90.2851L65.3875 86.8354L63.7821 80.8765Z",
    fill: "#FEF6E9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7129 115.286L69.7129 72.6445L17.8458 72.6445L17.8458 115.286H69.7129Z",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120 111.967L120 103.719L27.0992 103.719L27.0992 111.967L120 111.967Z",
    fill: "#282750"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115.214 115.997L115.214 99.6797L31.8879 99.6797L31.8879 115.997L115.214 115.997Z",
    fill: "#A1D5FC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8838 99.6797V101.14H113.494V115.997H115.21V99.6797H31.8838Z",
    fill: "#FEF6E9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8838 114.299V101.386C31.8838 100.447 32.6479 99.6875 33.5919 99.6875H113.502C114.446 99.6875 115.21 100.447 115.21 101.386V114.299C115.21 115.238 114.446 115.998 113.502 115.998H33.5919C32.6479 115.998 31.8838 115.238 31.8838 114.299Z",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2758 43.5078C59.5826 44.1933 57.7321 44.5733 55.7917 44.5733C54.4207 44.5733 53.0946 44.387 51.8359 44.0294",
    stroke: "#1D1D1B",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8169 41.0487C52.8169 41.0487 61.4177 45.3479 61.9271 45.1914C62.4366 45.0349 70.0784 37.8672 70.0784 37.8672C70.0784 37.8672 71.8391 42.0844 72.3935 42.4942C72.9554 42.9114 98.2334 52.9105 98.2334 52.9105L100.136 52.5305C101.26 52.307 102.099 53.529 101.485 54.4901L105.178 65.6888H94.3225L90.5316 61.6206C89.8648 60.9054 88.8908 60.5477 87.9169 60.6595L84.6878 61.032C84.3657 59.512 82.9422 58.4764 81.3914 58.6179L79.3835 58.8042L79.361 58.7148C79.0389 57.165 77.5929 56.1219 76.0121 56.2933L73.8619 56.5242C73.8619 56.5242 71.4869 52.9851 69.4641 55.0639L67.0442 58.9905L64.2721 57.3066L64.4969 72.6331H53.6335L40.4775 64.7873L45.3923 51.8674L41.3841 46.8008L42.4854 43.0754H53.3188",
    fill: "#F8E6EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8169 41.0487C52.8169 41.0487 61.4177 45.3479 61.9271 45.1914C62.4366 45.0349 70.0784 37.8672 70.0784 37.8672C70.0784 37.8672 71.8391 42.0844 72.3935 42.4942C72.9554 42.9114 98.2334 52.9105 98.2334 52.9105L100.136 52.5305C101.26 52.307 102.099 53.529 101.485 54.4901L105.178 65.6888H94.3225L90.5316 61.6206C89.8648 60.9054 88.8908 60.5477 87.9169 60.6595L84.6878 61.032C84.3657 59.512 82.9422 58.4764 81.3914 58.6179L79.3835 58.8042L79.361 58.7148C79.0389 57.165 77.5929 56.1219 76.0121 56.2933L73.8619 56.5242C73.8619 56.5242 71.4869 52.9851 69.4641 55.0639L67.0442 58.9905L64.2721 57.3066L64.4969 72.6331H53.6335L40.4775 64.7873L45.3923 51.8674L41.3841 46.8008L42.4854 43.0754H53.3188",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4822 42.889L52.2385 46.8008L56.2468 51.8674L51.332 64.7872L64.488 72.633L75.1266 57.3065L77.8986 58.9904L80.3185 55.0638C82.3414 52.9776 84.7164 56.5242 84.7164 56.5242L86.8666 56.2932C88.4474 56.1218 89.8933 57.1724 90.2155 58.7147L90.238 58.8191L92.2458 58.6328C93.8041 58.4838 95.2201 59.5269 95.5423 61.0469L98.7713 60.6743C99.7453 60.5626 100.719 60.9202 101.386 61.6355L105.177 65.7037L112.339 54.505C112.954 53.5438 112.107 52.3219 110.991 52.5454L109.088 52.9254L82.3039 37.4648L79.0374 29.4551C79.0374 29.4551 73.0888 42.9337 72.5793 43.0902C72.0699 43.2467 59.1312 45.4894 59.1312 45.4894",
    fill: "#F8E6EB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8207 47.1373C57.8207 47.1373 70.7519 44.902 71.2614 44.7381C71.3662 44.7083 71.7109 44.0973 72.1754 43.1585C69.9278 43.5981 59.1318 45.4683 59.1318 45.4683L53.4829 42.8828L52.8535 44.8648L57.8207 47.1373Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8084 58.9746L64.376 72.5725L64.4884 72.6396L73.9208 59.0417L73.8084 58.9746Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0002 56.7356L77.6816 58.8666L77.8914 58.9932L79.5396 56.3184C79.3673 56.4227 79.18 56.5493 79.0002 56.7356Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.991 52.5395L109.088 52.9195L82.304 37.4589L79.0375 29.4492C79.0375 29.4492 78.6179 30.3955 77.9961 31.7888L80.9854 39.1205L107.769 54.5811L109.672 54.2011C110.796 53.9776 111.635 55.1995 111.021 56.1607L105.02 65.5339L105.17 65.6904L112.332 54.4917C112.961 53.538 112.115 52.316 110.991 52.5395Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4822 42.889L52.2385 46.8008L56.2468 51.8674L51.332 64.7872L64.488 72.633L75.1266 57.3065L77.8986 58.9904L80.3185 55.0638C82.3414 52.9776 84.7164 56.5242 84.7164 56.5242L86.8666 56.2932C88.4474 56.1218 89.8933 57.1724 90.2155 58.7147L90.238 58.8191L92.2458 58.6328C93.8042 58.4838 95.2201 59.5269 95.5423 61.0469L98.7713 60.6743C99.7453 60.5626 100.719 60.9202 101.386 61.6355L105.177 65.7037L112.339 54.505C112.954 53.5438 112.107 52.3219 110.991 52.5454L109.088 52.9254L82.3039 37.4648L79.0374 29.4551C79.0374 29.4551 73.0888 42.9337 72.5793 43.0902C72.0699 43.2467 59.1312 45.4894 59.1312 45.4894",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3715 61.5093L84.3504 49.4314C84.8748 48.6341 84.5677 47.5537 83.6986 47.1514L82.7696 46.7192C82.0204 46.3765 81.1364 46.6596 80.7318 47.3749L73.6893 59.8775C73.045 61.0175 74.0114 62.3959 75.3151 62.1873C75.7421 62.1202 76.1317 61.8744 76.3715 61.5093Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M55.88 62.4105L58.5921 56.0549C59.0192 55.0491 60.4202 54.9447 60.9971 55.8836L66.4437 64.7725C66.7134 65.2121 66.706 65.7709 66.4213 66.203L65.2001 68.0732C64.7955 68.6916 63.9639 68.8705 63.3346 68.4756L56.397 64.0646C55.8351 63.7144 55.6178 63.0141 55.88 62.4105Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1264 28.704C53.1264 28.704 60.9855 28.704 64.0197 19.7555C73.5046 16.492 71.1821 23.1531 71.1821 23.1531C71.1821 23.1531 67.9755 30.6264 72.1036 35.9016C72.1036 35.9016 75.1528 41.5643 67.5485 39.6494C67.5485 39.6494 65.2109 34.4338 54.415 35.2832C54.415 35.2757 46.6833 31.7887 53.1264 28.704Z",
    fill: "#F8E6EB",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4026 13.25C56.8992 13.25 49.999 20.7978 49.999 30.1039C49.999 39.4101 56.8917 46.9579 65.4026 46.9579C73.906 46.9579 80.8061 39.4101 80.8061 30.1039C80.8061 20.7978 73.9135 13.25 65.4026 13.25ZM65.4026 40.4756C60.1657 40.4756 55.9252 35.8337 55.9252 30.1039C55.9252 24.3742 60.1657 19.7323 65.4026 19.7323C70.6395 19.7323 74.88 24.3742 74.88 30.1039C74.88 35.8337 70.6395 40.4756 65.4026 40.4756Z",
    fill: "#FEF6EB"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8398 31.3694C54.8398 37.0991 59.0803 41.741 64.3172 41.741C67.3365 41.741 70.0186 40.1912 71.7567 37.7846C70.0785 39.4536 67.8534 40.4744 65.4035 40.4744C60.1666 40.4744 55.9261 35.8325 55.9261 30.1027C55.9261 27.6812 56.6904 25.4534 57.964 23.6875C56.0535 25.5875 54.8398 28.322 54.8398 31.3694Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4028 13.25C60.6828 13.25 56.4573 15.5747 53.6328 19.2405C56.4049 16.3198 60.1658 14.5167 64.3164 14.5167C72.8198 14.5167 79.72 22.0644 79.72 31.3706C79.72 35.5133 78.3564 39.2983 76.0864 42.234C78.9932 39.1717 80.8063 34.8651 80.8063 30.1039C80.8063 20.7903 73.9137 13.25 65.4028 13.25Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4026 13.25C56.8992 13.25 49.999 20.7978 49.999 30.1039C49.999 39.4101 56.8917 46.9579 65.4026 46.9579C73.906 46.9579 80.8061 39.4101 80.8061 30.1039C80.8061 20.7978 73.9135 13.25 65.4026 13.25ZM65.4026 40.4756C60.1657 40.4756 55.9252 35.8337 55.9252 30.1039C55.9252 24.3742 60.1657 19.7323 65.4026 19.7323C70.6395 19.7323 74.88 24.3742 74.88 30.1039C74.88 35.8337 70.6395 40.4756 65.4026 40.4756Z",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1963 33.3762C65.8224 33.3762 67.1407 31.9851 67.1407 30.2691C67.1407 28.5532 65.8224 27.1621 64.1963 27.1621C62.5702 27.1621 61.252 28.5532 61.252 30.2691C61.252 31.9851 62.5702 33.3762 64.1963 33.3762Z",
    fill: "#FFB49E",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9395 33.3762C66.5656 33.3762 67.8838 31.9851 67.8838 30.2691C67.8838 28.5532 66.5656 27.1621 64.9395 27.1621C63.3133 27.1621 61.9951 28.5532 61.9951 30.2691C61.9951 31.9851 63.3133 33.3762 64.9395 33.3762Z",
    fill: "#F8E6EB",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3918 43.5078C68.8559 44.1933 67.1702 44.5733 65.4096 44.5733C64.166 44.5733 62.9523 44.387 61.8135 44.0294",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5898 17.1006C61.343 16.1618 63.3209 15.6328 65.4036 15.6328C72.7083 15.6328 78.627 22.1151 78.627 30.1025C78.627 34.7295 76.6416 38.8498 73.5474 41.5023",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M83.541 50.6465C83.541 50.6465 96.1051 54.1559 99.8061 58.6562L83.541 50.6465Z",
    fill: "#F8E6EB"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M83.541 50.6465C83.541 50.6465 96.1051 54.1559 99.8061 58.6562",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M109.096 52.9199L104.047 58.6571",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3335 64.7949H40.4775",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2467 46.8008H41.5332",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4759 33.8025C50.4759 33.8025 52.5586 45.4706 52.7834 45.7611H41.8975L39.4102 33.0723",
    fill: "#FEF6EB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4759 33.8025C50.4759 33.8025 52.5586 45.4706 52.7834 45.7611H41.8975L39.4102 33.0723",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8982 45.5483C52.9731 45.4663 54.2917 41.8079 54.2168 41.7409C54.1419 41.6738 51.3398 36.9648 51.3398 36.9648L52.8982 45.5483Z",
    fill: "#282750"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1113 72.6418L53.4007 66.0254L62.0015 71.1591L60.8852 72.6418H48.1113Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6881 61.0414H95.544C95.544 61.0414 95.3193 57.8673 90.2172 58.7167C86.8009 58.7167 79.3613 58.7167 79.3613 58.7167C79.3613 58.7167 83.4669 58.0163 84.6881 61.0414Z",
    fill: "#F8E6EB",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8843 70.8535L24.3174 89.4584L34.2593 93.9066L43.7816 70.8535H31.8843Z",
    fill: "#FEF6EB",
    stroke: "#282750",
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4159 71.1953H40.4551V72.2757H51.4159V71.1953Z",
    fill: "#FEF6EB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6702 70.4883H40.4551V71.1961H49.6702V70.4883Z",
    fill: "#282750"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2356 71.1953L42.8068 72.2757L42.1325 74.0118L31.8535 72.2757L32.2356 71.1953Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9105 14.6219C57.9105 14.6219 49.8341 14.4282 50.0289 14.6219C50.2237 14.8156 52.2765 13.765 54.5241 13.6235C56.7717 13.4819 60.5027 13.6235 60.5027 13.6235L58.8769 14.1748",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0962 83.9668C26.9763 84.1605 29.606 91.291 29.606 91.291L24.8711 89.1005L27.0962 83.9668Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2705 30.7461C39.6002 30.7461 51.3326 41.5052 51.3326 41.5052L51.932 44.1577L40.4693 37.3327L39.2705 30.7461Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3359 24.6715L49.6335 30.4608C49.6335 30.4608 49.5511 28.3448 50.0006 26.2287C46.824 23.8295 41.9168 21.1621 41.9168 21.1621C41.9168 21.1621 40.3734 23.3676 40.3359 24.6715Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M56.247 51.875H46.6572",
    stroke: "#282750",
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5962 71.9565C61.5138 71.7926 52.4635 66.9421 52.4635 66.9421L49.9986 65.6829L41.645 65.4966C41.645 65.4966 40.9857 64.7962 41.1955 64.7962C41.4053 64.7962 51.7143 64.6621 51.7143 64.6621L64.3608 72.2769L61.4464 72.642L61.5962 71.9565Z",
    fill: "#282750"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9404 62.6121H71.4941C71.4941 62.6121 73.0974 60.4215 73.1199 60.496C73.1424 60.5705 74.2662 61.9713 74.2662 61.9713L74.9404 62.6121Z",
    fill: "#282750"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M45.9309 100.754L37.3301 115.626H43.1214L51.6697 101.141L45.6761 100.754",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M101.866 100.754L93.2656 115.626H99.0569L107.605 101.141L101.612 100.754",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M57.9856 100.754L49.3848 115.626H51.4151L59.956 101.141L57.7309 100.754",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.22,
    d: "M110.915 100.754L102.314 115.626H104.345L112.893 101.141L110.661 100.754",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4712 74.0118L36.9254 86.6262L35.1573 90.7167L29.2686 78.3482L31.2315 73.6914",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4105 73.3364L33.4355 92.8549L34.0499 93.2871L42.6657 72.6406",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.f210880c527572efe408d60450c58344.svg";
export { ForwardRef as ReactComponent };